<template>
    <section class="w-full">
        <div class="pda-default">
            <div class="t-headline5">
                {{$t('1608')}}
                <!-- 개인정보 입력 -->
            </div>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('1609')}}
                <!-- 이름을 입력하세요. -->
            </div>
            <form @submit.prevent="next()" novalidate>
            <div class="mgt-35">
                <div class="mdc-text-field mdc-text-field--outlined w-full  gt-7"
                    :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="lastNameEl"
                >
                    <input type="text" class="mdc-text-field__input"
                        id="lastName"
                        name="lastName"
                        v-validate="'required'"
                        ref="lastName"
                        maxlength="50"
                        :value="lastName"
                        @input="e => handleInput(e, 'lastName')"
                        v-lowercase
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">{{$t('1610')}}</label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && lastNameInvalidCheck">
                        {{$t('951')}}
                    </span>
                </div>

                <div class="mdc-text-field mdc-text-field--outlined w-full"
                    :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="firstNameEl"
                >
                    <input type="text" class="mdc-text-field__input"
                        v-validate="'required'"
                        ref="firstName"
                        id="firstName"
                        name="firstName"
                        maxlength="50"
                        :value="firstName"
                        @input="e => handleInput(e, 'firstName')"
                        v-lowercase
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">{{$t('1611')}}</label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                <div class="t-helper t-color-red1 mgl-7 mgr-7 pdt-2 min-h-23">
                    <span v-show="submitState && firstNameInvalidCheck">
                        {{$t('952')}}
                    </span>
                </div>
                
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('1612')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelJoin()" type="button">
                    {{$t('1613')}}
                    <!-- 취소 -->
                </button>
                
            </div>
            </form>
        </div>
    </section>
    
</template>

<script>
/**
 * 회원가입 - 이름입력(sign up - input name component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            firstName: '',
            lastName: '',
            firstNameTextField: null,
            lastNameTextField: null,
            submitState: false
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // firstName 유효성 Check(validation firstName)
        firstNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('firstName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
            return returnValue
        },

        // lastName 유효성 Check(validation lastName)
        lastNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('lastName')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
            return returnValue
        },
    },

    created() {
        if (!this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE) {
            this.moveJoin2Intro()
        }
    },

    mounted() {
        this.setMaterialUi()
        this.$refs.lastName.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('join', ['SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL']),

        setMaterialUi() {
            this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
            this.firstNameTextField.useNativeValidation = false

            this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
            this.lastNameTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

            this.firstName = this.join.name.first
            this.lastName = this.join.name.last
            this.firstNameTextField.value = this.firstName
            this.lastNameTextField.value = this.lastName
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_NAME_FIRST(this.firstName)
                    this.SET_NAME_LAST(this.lastName)
                    this.SET_NAME_FULL(this.firstName + ' ' + this.lastName)
                    
                    // console.log('NEXT')
                    this.$router.push({name: 'Join2Email'})                    
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        },
        handleInput(e, type) {
            const key = type === "firstName" ? "firstName" : "lastName";
            this[key] = e.target.value;
        }
    },
}
</script>